import * as Comp from "../../../common/CommonComponents";
import * as common from "../../../common/common";
import http from "../../../common/http-common";
import { useState } from "react";
import { toast } from "react-toastify";
import { useCookies } from "react-cookie";

const AckTicket = (props) => {
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);

  const message = (
    <>
      Confirm to acknowledge?
      <br />
      Ticket Num:
      {<b>{props.viewData !== null && props.viewData.TICKET_NUM}</b>}
    </>
  );

  const SendEmail = (_data) => { 
    let functionName = "onSaveConfirmHandler";

    try {
        props.onLoading(true, "Sending email, please wait...");
        const data = {
            // TICKET_MST_ID: ticketMstId,
            TICKET_MST_ID: _data.TICKET_MST_ID,
            TICKET_NUM: _data.TICKET_NUM, 
            ORG_ID: _data.ORG_ID,   
            ORG_NAME: _data.ORG_NAME,
            SYSTEM_MST_ID: _data.SYSTEM_MST_ID,
            SYSTEM_MST_NAME: _data.SYSTEM_MST_NAME,
            UPDATE_ID: userId,
        };
        http
            .post("api/Ticket/SendAckEmail", data, { timeout: common.DEFAULT_TIMEOUT })
            .then((response) => {
              props.onLoading(true, "Sending email...");
            })
            .catch((err) => {    
                common.c_LogWebError(props.page, functionName, err);
            })
            .finally(() => {
                props.onLoading(false, "Loading...");
            })


    } catch (err) {
        props.onLoading(false, "Loading...");
        toast.error("Failed to send");
        common.c_LogWebError(props.page, functionName, err);
    }
  };

  const AckBtnOnClick = () => {
    AcknowledgeTicket(props.viewData);
  }

  function AcknowledgeTicket(_data) {
    let functionName = "";
    try {
      functionName = AcknowledgeTicket.name;

      props.onLoading(true, "Acknowledging ticket, please wait...");

      const data = {
        TICKET_MST_ID: _data.TICKET_MST_ID,
        TICKET_NUM: _data.TICKET_NUM,
        TICKET_STATUS_TYPE_ID: _data.TICKET_STATUS_TYPE_ID,
        TICKET_STATUS_TYPE_NAME: _data.TICKET_STATUS_TYPE_NAME,
        // ACKNOWLEDGED_BY: _data.ACKNOWLEDGED_BY,
        // ACKNOWLEDGED_DATETIME:
        //   _data.ACKNOWLEDGED_DATETIME === "0001-01-01T00:00:00"
        //     ? null
        //     : _data.ACKNOWLEDGED_DATETIME,
        UPDATE_ID: userId,
        UPDATE_DATETIME: _data.UPDATE_DATETIME,
      };

      http
        .put("api/ticket/AcknowledgeTicket", data, { timeout: 10000 })
        .then((response) => {
          if (response.data.OPEN_STATUS === false) {
            if (response.data.TICKET_STATUS_TYPE_NAME === "CLOSED") {
              toast.error("Ticket " + response.data.TICKET_NUM + " has been " + response.data.TICKET_STATUS_TYPE_NAME.toLowerCase() + '.');   
            } else if (response.data.TICKET_STATUS_TYPE_NAME === "CANCEL") {
              toast.error("Ticket " + response.data.TICKET_NUM + " has been " + response.data.TICKET_STATUS_TYPE_NAME.toLowerCase() + 'led.');   
            } else if (response.data.TICKET_STATUS_TYPE_NAME === "ACKNOWLEDGE") {
              toast.error("Ticket " + response.data.TICKET_NUM + " has been " + response.data.TICKET_STATUS_TYPE_NAME.toLowerCase() + 'd.');   
            }                
            props.onReload();
            hideModal();
          }
          else {
            toast.success("Ticket is successfully acknowledged.");
            SendEmail(_data);
            props.onReload();
            hideModal();
          }     
        })
        .catch((err) => {
          toast.error("Failed to acknowledge ticket. Please try again.");
          common.c_LogWebError(props.page, functionName, err);
        })
        .finally(() => {
          props.onLoading(false, "Loading...");
        });
    } catch (err) {
        props.onLoading(false, "Loading...");
        toast.error("Failed to acknowledge ticket. Please try again.");
        common.c_LogWebError(props.page, functionName, err);
    }
  }
  
  const hideModal = () => {
    props.onHide();
  };

  return (
      <>
        <Comp.ConfirmModal
          show={props.showHide}
          onHide={hideModal}
          onConfirm={AckBtnOnClick}
        >
          {message}
        </Comp.ConfirmModal>
      </>
  );
}

export default AckTicket;